import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_BASE_URL, SITE_URL } from 'src/configurations/constants';

// bring in stripe here
declare const Stripe;

@Injectable({
  providedIn: 'root',
})
export class MembershipService {
  baseUrl: string = API_BASE_URL;

  public membership: BehaviorSubject<any> = new BehaviorSubject<any>('');

  constructor(private http: HttpClient) {}

  getProducts(partner: null | string = null, CID: null | string = null): Observable<any> {
    const $httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'language-iso': 'en',
      }),
    };

    let url: string = this.baseUrl + '/subscription/products';
    if (partner) {
      url += `?subtype=${partner}`;
    }

    if (CID) {
      url += `?CID=${CID}`;
      // url += `?CID=85500`; // to test
    }

    return this.http.get<any>(url, $httpOptions);
  }

  getFeatures(): Observable<any> {
    const $httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(this.baseUrl + '/subscription/feature', $httpOptions);
  }

  getMembership() {
    const $token = localStorage.getItem('token');

    const $httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: $token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(this.baseUrl + '/payment/membership', $httpOptions);
  }

  private requestMembershipSession(body: any): Observable<any> {
    const $token = localStorage.getItem('token');

    const $httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: $token,
        'language-iso': 'en',
      }),
    };

    return this.http
      .post<any>(this.baseUrl + '/payment/create_checkout_session', body, $httpOptions)
      .pipe(
        map(response => {
          return {
            sessionId: response.SESSION.id,
            publishableKey: response.PUBLISHABLE_KEY,
          };
        })
      );
  }

  subscribe(body: any) {
    this.requestMembershipSession(body).subscribe(response => {
      this.redirectToCheckout(response.sessionId, response.publishableKey);
    });
  }

  redirectToCheckout(sessionId: string, publishableKey: string) {
    const stripe = Stripe(publishableKey);

    stripe.redirectToCheckout({
      sessionId: sessionId,
    });
  }

  cancelMembership(id: string) {
    const $token = localStorage.getItem('token');

    const $httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: $token,
        'language-iso': 'en',
      }),
    };

    return this.http.get<any>(
      this.baseUrl + `/membership/cancel?sub_id=${id}`,
      $httpOptions
    );
  }

  updateMembership($body: any) {
    const $token = localStorage.getItem('token');

    const $httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: $token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(this.baseUrl + '/membership/update', $body, $httpOptions);
  }
}
